import React, { useEffect, useState } from "react";

import "../Styles/index.css";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getApplicationResults, getApplications } from "../Store/Thunk";
import ExcelDownload from "./ExcelDownload";
import Form from "react-bootstrap/Form";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { reactSelectStyles } from "../../../SharedComponents/reactSelectStyles";
import { ClearApplicationResults } from "../Store";

export default function ApplicationResults() {
  const applications = useSelector((state) => state.applicationResults.applications);
  const applicationResults = useSelector((state) => state.applicationResults.applicationResults);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    return () => {
      dispatch(ClearApplicationResults());
    };
  }, []);

  const getTomorrowDate = () => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1); // Add one day
    return tomorrow.toISOString().split("T")[0]; // Format: YYYY-MM-DD
  };

  const getMonthBeforeToday = () => {
    const pastDate = new Date();
    pastDate.setDate(pastDate.getDate() - 30); // Move back 30 days
    return pastDate.toISOString().split("T")[0]; // Format: YYYY-MM-DD
  };
  const [selectedApplication, setSelectedApplication] = useState(null);
  const [applicationSelectOptions, setApplicationSelectOptions] = useState(null);

  const [startDate, setStartDate] = useState(getMonthBeforeToday());
  const [endDate, setEndDate] = useState(getTomorrowDate());

  useEffect(() => {
    if (applications) {
      setApplicationSelectOptions(
        applications?.map((application, i) => ({
          value: application.id,
          label: application.name,
          ...application,
        }))
      );
    }
  }, [applications]);

  useEffect(() => {
    dispatch(getApplications());
  }, []);

  useEffect(() => {
    if (selectedApplication?.applicationType != null && selectedApplication?.id != null && startDate && endDate) {
      dispatch(
        getApplicationResults({
          applicationType: selectedApplication.applicationType,
          applicationId: selectedApplication.id,
          startDate: startDate,
          endDate: endDate,
        })
      );
    }
  }, [selectedApplication, startDate, endDate]);

  return (
    <Row>
      <Col>
        <Form>
          <Row>
            <Col>
              <Form.Group>
                <Form.Label>Değerleme</Form.Label>
                <Select
                  placeholder={"Değerleme"}
                  styles={reactSelectStyles}
                  options={applicationSelectOptions}
                  value={selectedApplication}
                  onChange={(selected) => {
                    setSelectedApplication(selected);
                  }}
                />
              </Form.Group>
            </Col>

            <Col>
              <Form.Group className={" d-flex flex-column h-100"}>
                <Form.Label>{t("Start Date")}</Form.Label>
                <Form.Control
                  className={"flex-grow-1"}
                  type="date"
                  value={startDate}
                  max={endDate || getTomorrowDate()}
                  onChange={(e) => setStartDate(e.target.value)}
                />
              </Form.Group>
            </Col>

            <Col>
              <Form.Group className={" d-flex flex-column h-100"}>
                <Form.Label>{t("End Date")}</Form.Label>
                <Form.Control
                  className={"flex-grow-1"}
                  type="date"
                  value={endDate}
                  min={startDate}
                  max={getTomorrowDate()}
                  onChange={(e) => setEndDate(e.target.value)}
                />
              </Form.Group>
            </Col>

            <Col xs={"auto"} className="text-center">
              <Form.Group>
                <Form.Label>{t("Results")}</Form.Label>
                <Row className={"justify-content-center text-20 fw-semibold"}>
                  {applicationResults?.length ? applicationResults.length : 0}{" "}
                </Row>
                <Row className={"justify-content-center"}> {t("Rows available")}</Row>
              </Form.Group>
            </Col>

            <Col xs={"auto"}>
              <ExcelDownload
                isDisabled={!Boolean(applicationResults)}
                candidatesData={applicationResults}
                fileName={`${selectedApplication?.name} ${startDate} ${endDate}`}
              />
            </Col>
          </Row>
        </Form>
      </Col>
    </Row>
  );
}
